import { buildUrl } from '@axa-fr-axion/restful';
import { getDeviceType } from '@axa-fr-axion/utils';

const buildFolderUrl = (config) => buildUrl(
  [
    config.bffHost,
    config.bffPathName,
    config.bffFolderPathName
  ]
);
const buildFindAdvisorsUrl = (config, folderId, leadId) => buildUrl(
  [
    buildFolderUrl(config),
    folderId,
    config.bffLeadPathName,
    leadId,
    config.bffFindAdvisorsEndpoint
  ]
);
const buildRequestContactUrl = (config, folderId, leadId) => buildUrl(
  [
    buildFolderUrl(config),
    folderId,
    config.bffLeadPathName,
    leadId,
    config.bffRequestContactEndpoint
  ]
);
function withDevice(proprietes) {
  const deviceType = getDeviceType();
  const valeur = deviceType === "Desktop" ? "Desktop" : "Mobile";
  return [
    ...proprietes ?? [],
    {
      nom: "device",
      valeur
    }
  ];
}
function withSelectedAdvisor(origin) {
  const selectedAdvisorItem = sessionStorage.getItem("selectedAdvisor");
  if (!selectedAdvisorItem) {
    return origin ?? {};
  }
  if (origin?.source === "XEC" || origin?.source === "SITE") {
    return origin ?? {};
  }
  const selectedAdvisor = JSON.parse(selectedAdvisorItem);
  const items = Object.keys(selectedAdvisor).map((key) => ({
    nom: key,
    valeur: selectedAdvisor[key]
  }));
  return {
    ...origin,
    source: "SITE",
    items: [...origin?.items ?? [], ...items]
  };
}

const buildIdentifyUrl = (config) => buildUrl(
  [
    config.bffHost,
    config.bffPathName,
    config.bffPersonPathname,
    config.bffIdentifyEndpoint
  ]
);

export { withDevice as a, buildFolderUrl as b, buildFindAdvisorsUrl as c, buildRequestContactUrl as d, buildIdentifyUrl as e, withSelectedAdvisor as w };
